/**
 * Formats a number with thousands separators and optional unit
 * @param number - Number to format
 * @param precision - Number of decimal places (default: 0)
 * @param unit - Optional unit to append (default: '')
 * @returns Formatted number string with commas and optional unit
 */
export default function numberWithCommas(
  number: number | string = 0,
  precision: number = 0,
  unit: string = ''
): string {
  number = number || 0
  const parsedUnit = unit ? (unit === '%' ? unit : `\u00A0${unit}`) : ''
  let n = number
  const newNumber = Number(number.toString().replace(',', '.'))
  if (isNaN(newNumber)) {
    return Number(0).toFixed(precision)
  }
  n = Number.parseFloat(newNumber.toString()).toFixed(precision)
  // const parsedNumber = n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0') // Unicode U+00A0 => non breaking space
  const numberString = n.toString()
  let formattedNumber = ''
  let count = 0
  for (let i = numberString.length - 1; i >= 0; i--) {
    if (numberString[i] === '.') {
      formattedNumber = '.' + formattedNumber
      count = 0 // Reset the count after encountering a decimal point
    } else {
      formattedNumber = numberString[i] + formattedNumber
      count++
      if (count % 3 === 0 && i !== 0) {
        formattedNumber = '\u00A0' + formattedNumber
      }
    }
  }
  const parsedNumber = formattedNumber

  return parsedNumber + parsedUnit
}
